import { Component } from '@angular/core';

@Component({
  selector: 'app-patreon-icon',
  imports: [],
  templateUrl: './patreon-icon.component.html',
  styleUrl: './patreon-icon.component.less'
})
export class PatreonIconComponent {

}
